'use strict';

exports.__esModule = true;
exports['default'] = mapProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _validators = require('../../utils/validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function mapProps(mapFunc) {
  return function (Target) {
    (0, _validators.validateClass)(Target, 'mapProps');

    return function (props) {
      return _react2['default'].createElement(Target, mapFunc(props));
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/mapProps.js
// module id = 552
// module chunks = 1